import { useEffect, useRef, useState } from 'react';

import api from '../../../services/api';

// Kullanıcı yazarken her tuşta istek atmamak için bekleme (ms).
const DEBOUNCE_MS = 400;

// Giriş ekranındaki canlı politika önizlemesi. Tek otorite sunucudur: aylık
// limit için çalışanın ay-içi toplamı gerekir, istemci bunu bilemez. Uç
// ulaşılamazsa `preview` boş kalır ve çağıran yerel işlem başı hesabına düşer.
export function useExpensePolicyPreview({ categoryId, amount, currency = 'TRY' }) {
  const [preview, setPreview] = useState(null);
  const [loading, setLoading] = useState(false);
  // Geç gelen eski yanıt taze önizlemeyi ezmesin.
  const seqRef = useRef(0);

  useEffect(() => {
    const numericAmount = Number(amount) || 0;

    if (!categoryId || numericAmount <= 0) {
      seqRef.current += 1;
      setPreview(null);
      setLoading(false);
      return undefined;
    }

    const seq = ++seqRef.current;
    setLoading(true);

    const timer = setTimeout(() => {
      const query = new URLSearchParams({
        categoryId,
        amount: String(numericAmount),
        currency,
      });

      api.get(`/v1/expenses/my/policy-preview?${query}`)
        .then((res) => {
          if (seq !== seqRef.current) return;
          setPreview(res?.data?.data || null);
        })
        .catch(() => {
          if (seq !== seqRef.current) return;
          setPreview(null);
        })
        .finally(() => {
          if (seq !== seqRef.current) return;
          setLoading(false);
        });
    }, DEBOUNCE_MS);

    return () => clearTimeout(timer);
  }, [categoryId, amount, currency]);

  return { preview, loading };
}

export default useExpensePolicyPreview;
